import { render, staticRenderFns } from "./mallIot.vue?vue&type=template&id=4b7678f6&scoped=true&"
import script from "./mallIot.vue?vue&type=script&lang=js&"
export * from "./mallIot.vue?vue&type=script&lang=js&"
import style0 from "./mallIot.vue?vue&type=style&index=0&id=4b7678f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7678f6",
  null
  
)

export default component.exports